import React, {Component} from 'react';
import {Line} from 'react-chartjs-2';
import {injectIntl} from 'react-intl';
import {getAccumulation, getChartDataByDay, getGradients, getSum} from './budget_charts_util';

class RevenueChart extends Component {
	getChartData() {
		const {formatMessage} = this.props.intl;
		const {forecastPerDay, actualPerDay, remainingPerDay, baselinePerDay, project, labels} = this.props.data;
		const {itemsOutsideProjectPeriod, isEstimatedInNewPoints, showBaseline, filters, isFixedPriceV2} = this.props;
		const {gradientStroke, gradientFill, gradientStrokeActual, gradientFillActual, gradientStrokeFixedPrice, gradientStrokeBaseline} = getGradients();

		const actualRevenue = getAccumulation(getChartDataByDay({project, dayData: actualPerDay, projection: false}));
		const plannedRevenue = getAccumulation(getChartDataByDay({project, dayData: forecastPerDay}));

		const datasets = [];

		const checkFilter = name => {
			return filters.some(filter => filter && filter.name === name && filter.checked);
		};
		if (checkFilter('plan') && !isEstimatedInNewPoints) {
			datasets.push({
				label: formatMessage({id: 'project_budget.planned_revenue'}),
				borderColor: gradientStroke,
				pointHoverRadius: 0,
				pointHoverBorderWidth: 2,
				pointBackgroundColor: 'rgba(217, 248, 232, 0.2)',
				pointHoverBorderColor: '#fff',
				pointRadius: 0,
				fill: true,
				backgroundColor: gradientFill,
				borderWidth: 2,
				data: plannedRevenue,
			});
		}
		if (checkFilter('actual')) {
			datasets.push({
				label: formatMessage({id: 'project_budget.actual_revenue'}),
				borderColor: gradientStrokeActual,
				pointBackgroundColor: 'rgba(234, 248, 255, 0.8)',
				pointHoverBorderColor: '#fff',
				pointHoverRadius: 0,
				pointHoverBorderWidth: 2,
				pointRadius: 0,
				fill: true,
				backgroundColor: gradientFillActual,
				borderWidth: 2,
				data: actualRevenue,
			});
		}

		const firstActualNullIndex = actualRevenue.findIndex(number => number === null);
		if (firstActualNullIndex !== -1 && checkFilter('forecast')) {
			const actualRevenuePerDayPast = getChartDataByDay({project, dayData: actualPerDay}).fill(null, firstActualNullIndex, actualPerDay.length);
			const remainingRevenuePerDay = getChartDataByDay({project, dayData: remainingPerDay});

			const forecastRevenueAcc = getAccumulation(getSum(actualRevenuePerDayPast, remainingRevenuePerDay)).fill(null, 0, firstActualNullIndex !== 0 ? firstActualNullIndex - 1 : 0);
			forecastRevenueAcc[firstActualNullIndex - 1] = getAccumulation(actualRevenuePerDayPast)[firstActualNullIndex - 1];

			const chartProps = {
				label: formatMessage({id: 'common.forecast'}),
				borderColor: gradientStrokeActual,
				pointHoverRadius: 0,
				pointHoverBorderWidth: 2,
				pointBackgroundColor: 'transparent',
				pointHoverBorderColor: '#fff',
				pointRadius: 0,
				fill: true,
				backgroundColor: 'transparent',
				borderWidth: 2,
				data: forecastRevenueAcc,
				borderDash: [4, 2],
			};
			datasets.unshift(chartProps);
		}

		const isFixedPrice = !!project.budget;
		if (isFixedPrice && (checkFilter('fixedPrice') || isFixedPriceV2)) {
			const fixedPriceData = labels.map(() => project.budget);
			const dataset = {
				label: formatMessage({id: 'common.fixed_price'}),
				borderColor: gradientStrokeFixedPrice,
				pointHoverRadius: 0,
				pointHoverBorderWidth: 2,
				pointBackgroundColor: 'transparent',
				pointHoverBorderColor: gradientStrokeFixedPrice,
				pointRadius: 0,
				fill: false,
				backgroundColor: '#fff',
				borderWidth: 2,
				data: fixedPriceData,
			};
			datasets.unshift(dataset);
		}

		if (showBaseline && checkFilter('baseline')) {
			const baselineRevenue = getAccumulation(getChartDataByDay({project, dayData: baselinePerDay}));
			datasets.unshift({
				label: formatMessage({id: 'baseline.baseline'}),
				borderColor: gradientStrokeBaseline,
				pointHoverRadius: 0,
				pointHoverBorderWidth: 2,
				pointBackgroundColor: 'transparent',
				pointHoverBorderColor: gradientStrokeBaseline,
				pointRadius: 0,
				fill: true,
				backgroundColor: 'transparent',
				borderWidth: 2,
				data: baselineRevenue,
				borderDash: [7, 4],
			});
		}

		if (itemsOutsideProjectPeriod) datasets.push(itemsOutsideProjectPeriod);
		return {
			datasets,
			labels,
		};
	}

	render() {
		return <Line data={this.getChartData()} options={this.props.options} plugins={this.props.plugins} redraw />;
	}
}

export default injectIntl(RevenueChart);
